import { useEffect, useRef, useState } from 'react';
import { supabase } from '../../supabaseClient';
import { useCurrentUserProfile } from '../../contexts/CurrentUserProfileContext';
import EditProfileForm from '../EditProfileForm';
import { PROFILE_SELECT_OWN } from '../EditProfile';
import { setWelcomeBeforeNext } from '../../lib/welcomeDemo';

/**
 * The welcome flow's profile step (Stage 10): the whole Edit profile form - photo, names, zip, phone, Instagram - without
 * its Cancel / Save row. Next saves (the bar waits for it, and stays put if a field is wrong). The form gets the full
 * row, loaded like Edit profile's: the app-wide profile has only name and photo, and the form saved its blanks over the
 * rest (Sam, 2026-10-26: names already saved showed empty). Until the row is in, Next saves nothing.
 */
export default function WelcomeProfile() {
  const { session, refetch } = useCurrentUserProfile();
  const userId = session?.user?.id ?? null;
  const [profile, setProfile] = useState(null);
  const submitRef = useRef(null);
  useEffect(() => {
    if (!userId) return undefined;
    let cancelled = false;
    supabase
      .rpc('get_my_profile')
      .select(PROFILE_SELECT_OWN)
      .maybeSingle()
      .then(({ data, error }) => {
        if (error) console.error('[WelcomeProfile] load profile failed:', error);
        if (!cancelled) setProfile(data ?? null);
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);
  useEffect(() => {
    setWelcomeBeforeNext(async () => (submitRef.current ? submitRef.current() : true));
    return () => setWelcomeBeforeNext(null);
  }, []);
  if (!profile) submitRef.current = null;
  return (
    <div className="welcome-profile">
      <h1 className="sr-only">Your profile</h1>
      {profile && (
        <EditProfileForm
          profile={profile}
          userId={userId}
          onSaved={refetch}
          submitRef={submitRef}
        />
      )}
    </div>
  );
}
